import $ from 'jquery';
import youtube from './youtube';
import debounce from '../utility/debounce';

const galleries = $('.article-gallery');

function init() {
    if (galleries.length < 1) return;

    galleries.each(function (i, el) {
        makeGallery(el);
    });
}

function makeGallery(gallery) {

    const $gallery = $(gallery);
    const $gallerySlidesContainer = $gallery.find('.article-gallery-slides');
    const $slides = $gallerySlidesContainer.find('.gallery-slide');
    const $slidesImageWraps = $($gallerySlidesContainer.find('.gallery-slide-image'));
    let currentSlide = 0;
    const slidesCount = $slides.length;

    // nav
    let $nav;
    let $navPrev;
    let $navNext;
    let $wrap;
    let $navCaption;
    let $navCaptionNext;
    let $navList;
    let $navListLi;
    const captions = [];

    //
    const isPortrait = $gallery.hasClass('article-gallery--portrait');
    const isCustomHeight = $gallery.hasClass('article-gallery--custom-height');
    let aspectRation = 0;
    let ratioLoaded = false;
    let pic_real_width;
    let pic_real_height;

    $gallery.addClass('preload');

    setupGallery();
    createNavigation();

    setSlide(currentSlide);
    $(window).on('resize', debounce(calcHeight, 50));
    // setTimeout(calcHeight, 300);


    function setupGallery() {


        $slides.each(function (i, el) {
            const $slide = $(el);
            $slide.css({
                'position': 'absolute'
            });

            captions.push($slide.find('.gallery-slide-caption').html());
            /*
                $($slide.find(".gallery-slide-title")).css({
                    "margin-bottom": topOffset + "px"
                })
            */
        });

        $gallerySlidesContainer.addClass('gallery-active');


        let topOffset = (slidesCount * 5);

        if (topOffset > 20) {
            topOffset = 20;
        }

        $gallerySlidesContainer.css({
            'margin-top': topOffset + 'px'
        });

        checkPortraitFeatures();
        setAspectRation();
    }

    function setAspectRation() {

        // find first img in gallery
        const img = $($gallery.find('img')[0]);

        $('<img/>') // Make in memory copy of image to avoid css issues
            .attr('src', $(img).attr('src'))
            .load($(img).attr('src'), function () {
                pic_real_width = this.width; // Note: $(this).width() will not
                pic_real_height = this.height; // work for in memory images.

                aspectRation = (pic_real_height) / (pic_real_width) * 100;
                // console.log(pic_real_height+" , "+pic_real_width + "= "+aspectRation);
                // console.log('isCustomHeight: ' + isCustomHeight);
                ratioLoaded = true;
                if (isCustomHeight) {
                    updateSlidesAspect();
                }
                calcHeight();
            });

    }

    function updateSlidesAspect() {

        if (isPortraitSplitSlides() && isPortrait) {
            let aspectPercent = Math.ceil((pic_real_height / 2) / (pic_real_width - 2) * 100);
        } else {
            let aspectPercent = Math.ceil((pic_real_height) / (pic_real_width - 2) * 100);
        }

        $slidesImageWraps.css({
            'padding-bottom': aspectPercent + '%'
        });
    }

    function isPortraitSplitSlides() {

        if (window.matchMedia('(min-width: 570px)').matches) {
            return true;
        }
        return false;

    }

    function checkPortraitFeatures() {
        if (isPortrait && slidesCount == 2) {
            $gallery.addClass('gallery-active--two');
        }
    }


    function prevSlide() {
        let prev = currentSlide - 1;
        if (prev < 0) {
            prev = slidesCount - 1;
        }
        setSlide(prev);
    }

    function nextSlide() {
        let next = currentSlide + 1;
        if (next > slidesCount - 1) {
            next = 0;
        }
        setSlide(next);
    }

    function setSlide(index) {
        $slides.each(function (i, el) {
            const $slide = $(el);
            $slide.removeClass('previous-slide').removeClass('back-slide');
            let newPos = slidesCount - index + i;

            if (newPos > slidesCount - 1) {
                newPos = newPos - slidesCount;
            }
            $slide.attr('data-slideindex', newPos);


            if (newPos == slidesCount - 1 && $slides.length > 3) {
                $slide.addClass('previous-slide');
            }
            if (newPos == slidesCount - 2 && $slides.length > 3) {
                $slide.addClass('back-slide');
            }

        });
        if (youtube.hasVideo()) {
            youtube.stopAllVideo();
        }
        currentSlide = index;
        updateNavigation(currentSlide);
    }


    function createNavigation() {
        $nav = $('<nav class="article-gallery-navigation"></nav>');
        $navPrev = $('<a href="#" class="gallery-navigation-prev">prev</a>');
        $navNext = $('<a href="#" class="gallery-navigation-next">next</a>');
        $navCaption = $('<p class="gallery-navigation-caption"></p>');
        $navCaptionNext = $('<p class="gallery-navigation-caption"></p>');
        $navList = $('<ul class="gallery-navigation-list"></ul>');

        $wrap = $("<div class='article-gallery-navigation-wrap'></div>");
        $wrap.append($navPrev, $navList, $navNext);

        if ($navList.length < 1) return;

        for (let i = 0; i < slidesCount; i++) {
            $navList.append($('<li><a href="#">' + (i) + '</a></li>'));
        }
        $navListLi = $navList.find('li');

        $nav.append($wrap, $navCaption, $navCaptionNext);
        $gallery.append($nav);

        // bind clicks
        $navNext.on('click', function (e) {
            e.preventDefault();
            nextSlide();
        });
        $navPrev.on('click', function (e) {
            e.preventDefault();
            prevSlide();
        });
        $navListLi.each(function (i, el) {
            $(el).on('click', function (e) {
                e.preventDefault();
                setSlide(i);
            });
        });

        addSwipeNavigation();

    }

    function addSwipeNavigation() {
        $gallerySlidesContainer.on('swipeleft', function swipeLeft() {
            console.log('swipe left');
            nextSlide();
        });

        $gallerySlidesContainer.on('swiperight', function swipeRight() {
            console.log('swipe right');
            prevSlide();
        });
    }

    function updateNavigation(index) {
        $navListLi.each(function (i, el) {
            $(el).removeClass('gallery-navigation-active');
            // console.log( slidesCount +" - "+ index+"  "+ ( slidesCount - index) +" / "+ i);
            if (index == i) {
                $(el).addClass('gallery-navigation-active');
                updateNavCaption(captions[i]);

                if (i + 1 < $navListLi.length) {
                    updateNavNextCaption(captions[i + 1]);
                } else {
                    updateNavNextCaption(captions[0]);
                }
            }
        });
    }

    function updateNavCaption(content) {
        if (!content) {
            content = '';
        }
        $navCaption.stop().animate({'opacity': 0}, function () {
            $navCaption.html(content);
            $navCaption.animate({'opacity': 1});
        });

    }

    function updateNavNextCaption(content) {
        if (!content) {
            content = '';
        }
        $navCaptionNext.stop().animate({'opacity': 0}, function () {
            $navCaptionNext.html(content);
            $navCaptionNext.animate({'opacity': 1});
        });

    }

    function calcHeight() {

        $gallery.addClass('preload');

        let maxSlideHeigth = 0;
        let maxSlideWidth = 0;
        if (isCustomHeight) {
            if (!ratioLoaded){
                return;
            }
            updateSlidesAspect();
        }

        $slides.each(function (i, el) {
            const $slide = $(el);
            let h = 0;

            const children = $slide.find('.gallery-slide-title, .gallery-slide-image'); // removed .gallery-slide-caption
            const w = $slide.find('.gallery-slide-image').width();

            children.each(function (i, el) {
                const child = $(el);

                if (child.outerHeight()) {
                    h = h + child.outerHeight();
                }

            });

            if (h > maxSlideHeigth) {
                maxSlideHeigth = h;
            }
            if (w > maxSlideWidth) {
                maxSlideWidth = w;
            }
        });


        const aspectPercent = Math.ceil((maxSlideHeigth) / ($gallerySlidesContainer.width() - 2) * 100);
        $gallerySlidesContainer.css('padding-bottom', aspectPercent + '%');

        $gallery.removeClass('preload');
        $(window).trigger('lazyload');
    }
}

export default {
    init: init
};
